import { OBTS } from "src/common/constants";
import { SSOLinkI } from "src/types/SSOLink";
import { SSOLinksAction } from "../reducers/ssoLinks";

export const OBTS_SET_DATA = `${OBTS}_SET_DATA` as const;

export const setOBTS = (payload: SSOLinkI[]): SSOLinksAction => ({
  type: OBTS_SET_DATA,
  payload,
});
